// Shared lazy loader for the embedded Noto Sans PDF fonts.
//
// Z-Bericht (zReportPdf) uses these chunks to render Cyrillic / Turkish /
// Latin-extended glyphs in jsPDF.
// We dynamic-import the chunks so the ~1.5 MB base64 payload is split out of
// the main bundle and only fetched the first time a user generates a PDF.
//
// The watchdog rejects the cached promise after 30 s so a stuck network request
// (e.g. Cloudflare hiccup) doesn't leave the user with a spinner forever — the
// cache is cleared on timeout so the next click can retry from scratch.

const FONT_LOAD_TIMEOUT_MS = 30000

let fontsPromise = null

export const ensurePdfFonts = () => {
	if (fontsPromise) return fontsPromise

	const importPromise = Promise.all([
		import(/* webpackChunkName: "noto-sans-regular" */ './NotoSans-Regular'),
		import(/* webpackChunkName: "noto-sans-bold" */ './NotoSans-Bold'),
	]).then(([regular, bold]) => ({
		regular: regular.notoSansRegular,
		bold: bold.notoSansBold,
	}))

	const timeoutPromise = new Promise((_, reject) => {
		setTimeout(() => {
			fontsPromise = null // reset so next call can retry
			reject(new Error('FONT_LOAD_TIMEOUT'))
		}, FONT_LOAD_TIMEOUT_MS)
	})

	fontsPromise = Promise.race([importPromise, timeoutPromise])
	return fontsPromise
}

// Test-only helper: reset module-level cache so suites are isolated.
// eslint-disable-next-line no-underscore-dangle
export const __resetPdfFontsCache = () => { fontsPromise = null }
